import { render, staticRenderFns } from "./FourMatText1.vue?vue&type=template&id=97a20516&scoped=true&"
var script = {}
import style0 from "./FourMatText1.vue?vue&type=style&index=0&id=97a20516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a20516",
  null
  
)

export default component.exports